module.exports = __webpack_public_path__ + "static/media/68.89214a80.png";